import { Button, message, notification } from 'antd'
import { useEffect } from 'react'
import { errorResponse } from './errorResponse'
import { signOut } from 'firebase/auth'
import { useAuth, useFunctions } from 'reactfire'
import { useTranslation } from 'react-i18next'
import { api } from './api'

let acceptWasCalled = false
export default function useAcceptEmployerInvitation(
  searchParams,
  setSearchParams,
  successCallback
) {
  const auth = useAuth()
  const functions = useFunctions()
  const { t } = useTranslation()

  return useEffect(() => {
    if (acceptWasCalled) return
    acceptWasCalled = true
    // noinspection JSIgnoredPromiseFromCall
    acceptEmployerInvitationFromQueryString(
      searchParams,
      setSearchParams,
      successCallback,
      auth,
      functions,
      t
    )
    // Only execute once on mount
    // eslint-disable-next-line
  }, [])
}

async function acceptEmployerInvitationFromQueryString(
  searchParams,
  setSearchParams,
  successCallback,
  auth,
  functions,
  t
) {
  const clearInvitationParam = () => {
    searchParams.delete('employer_invitation')
    searchParams.delete('mode')
    searchParams.delete('email')
    searchParams.delete('demo')
    setSearchParams(searchParams)
  }

  async function acceptEmployerInvitationAction(employerInvitation) {
    message.loading({
      content: t('frontend:invitations.accepting'),
      duration: 0,
      key: 'employer_invitation',
    })
    const { companyUid } = await api(
      functions,
      'companies/accept_employer_invitation',
      {
        employerInvitation,
      }
    )
    message.destroy('employer_invitation')
    message.success(t('frontend:invitations.accepted'))
    clearInvitationParam()
    successCallback(companyUid)
  }

  if (searchParams.has('employer_invitation')) {
    const employerInvitation = searchParams.get('employer_invitation')
    try {
      await acceptEmployerInvitationAction(employerInvitation)
    } catch (error) {
      message.destroy('employer_invitation')
      if (error.code) {
        switch (error.code) {
          case 'functions/not-found':
          case 'functions/invalid-argument':
            message.error(t('frontend:invitations.invalid'))
            clearInvitationParam()
            break
          case 'functions/already-exists':
            message.warning({
              content: t('frontend:invitations.alreadyAccepted'),
              key: 'employer_invitation',
            })
            clearInvitationParam()
            break
          case 'functions/permission-denied':
            if (error.message === 'EMAIL_MISMATCH') {
              const invitationEmail = error.details?.email
              notification.error({
                key: 'employer-invitation-notification',
                message: t('frontend:invitations.otherAccountTitle'),
                description: (
                  <>
                    {t('frontend:invitations.emailMismatchDescription', {
                      invitationEmail,
                      currentEmail: auth?.currentUser?.email,
                    })}{' '}
                    <a href="mailto:support@cleverlohn.de">
                      support@cleverlohn.de
                    </a>
                    .
                  </>
                ),
                duration: 0,
                btn: (
                  <Button
                    block
                    danger
                    onClick={() => {
                      signOut(auth)
                      window.location.reload()
                    }}
                  >
                    {t('frontend:invitations.logout')}
                  </Button>
                ),
              })
            } else errorResponse(error)
            break
          default:
            errorResponse(error)
            break
        }
      } else {
        errorResponse(error)
      }
    }
  }
}
